const array = [
    {
        message: 'global.attributes.consignment',
        info: 'transfer.pack',
        icon: 'icon_box.png'
    },
    {
        message: 'global.attributes.pet',
        info: 'transfer.pet',
        icon: 'icon_pet.png'
    },
    {
        message: 'global.attributes.wheelchair',
        info: 'transfer.wheelchair',
        icon: 'icon_wheelchair.png'
    },
    {
        message: 'global.attributes.otherDay',
        info: 'transfer.otherDay',
        icon: 'icon-calendar-plus.png'
    },
    {
        message: 'global.attributes.returnJourney',
        info: 'transfer.round-trip',
        icon: 'icon-return.png'
    },
    {
        message: 'global.attributes.morning',
        info: 'transfer.morning',
        icon: 'icon-sun.png'
    },
    {
        message: 'global.attributes.night',
        info: 'transfer.evening',
        icon: 'icon-moon.png'
    }
];

export default array;
